import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout } from '../../api/queries';

export const useLogoutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => logout(),
    onSuccess: () => {
      queryClient.clear();
      window.location.href = '/';
    },
  });
};
